'use strict';
import _ from 'lodash';
import moment from 'moment';
import React, {
	forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import { Button, Loading } from './Control';
import { HAComponent, Link } from './Generic';
import ReactQuill, { Quill } from 'react-quill';
import styled from '@emotion/styled';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { AddBtn, BottomBtn, DragBtn, RemoveBtn, RiseBtn, SinkBtn, TopBtn } from './IconButton';
const { getLabel } = OptionUtils;
const { writeVal, resetVal, checkVal, readVal, wakeVal, freeVal, cancelAjax } = Utils;

const ColGroup = (props) => {
	if (!props.cols) return null;
	return <colgroup>{
		props.cols.map(c => <col key={_.uniqueId()} width={
			c == '*' ? '*' :
				props.unit === '%' ? `${c * 1}%` :
					_.isNumber(c) ? c : `${c}%`
		} />)
	}
	</colgroup>;
};

class TimeDisplayer extends React.Component {
	static propTypes = {
		value: PropTypes.number,				// in minutes...
		displayUnit: PropTypes.oneOf([1, 2, 3]),	// 1: min, 2: hour, 3: day, ...
	};
	static defaultProps = {
		value: 0,
		displayUnit: 2,
	};
	UNITS = {
		1: '分鐘',
		2: '小時',
		3: '天',
	};

	// toString(value = 0, unit = 2){
	// 	const mod = {
	// 		1: 1,
	// 		2: 60,
	// 		3: 60 * 24
	// 	}[unit];
	// 	const v = Math.floor(value / mod);
	// 	if(v == 0) return '';
	// 	return `${v} ${this.UNITS[unit]}`;
	// }

	render() {
		const { value, displayUnit } = this.props;
		const mod = {
			1: 1,
			2: 60,
			3: 60 * 24,
		}[displayUnit];
		const v = Math.floor(value / mod);
		return <span>
			{v === 0 ? '' : (v + ' ' + this.UNITS[displayUnit])}
			{value % mod === 0 ? '' : (value % mod + ' ' + this.UNITS[1])}
		</span>;
	}
}

class Freezing extends React.PureComponent {
	static version = '0.0.2';
	_dom = {};
	x = 0;
	y = 0;

	constructor(props) {
		super(props);
		this._scrolling = this._scrolling.bind(this);
		this.state = {};
	}

	componentDidMount() {
		const root = this._dom.root;
		if (root) {
			const parent = this.props.container || root.getParent();
			const { x, y } = parent.getSize();
			if (!root.getStyle('max-height')) root.setStyle('maxHeight', y);
			if (!root.getStyle('max-width')) root.setStyle('maxWidth', x);
			this.setState({ mountRoot: true });
		}
	}

	_scrolling() {
		const { x, y } = this.props.frozen;
		let scroll = this._dom.root.getScroll();

		if (x) {
			if (this.x === scroll.x) {
				this._dom.hor.style.zIndex = 6;
				this._dom.ver.style.zIndex = 5;
			}
			this._dom.ver.style.left = scroll.x;
			this.x = scroll.x;
		}
		if (y) {

			if (this.y === scroll.y) {
				this._dom.hor.style.zIndex = 5;
				this._dom.ver && (this._dom.ver.style.zIndex = 6);
			}
			this._dom.hor.style.top = scroll.y;
			this.y = scroll.y;
		}
		if (x && y) {
			this._dom.cross.style.top = scroll.y;
			this._dom.cross.style.left = scroll.x;
		}
	}

	render() {
		const { className, style, frozen, children } = this.props;
		const { x, y , frameWidth, frameHeight, xWidth, yWidth } = frozen;
		const { mountRoot } = this.state;

		return <div {... {
			ref: ele => {
				this._dom.root = ele;
			},
			className: `freezingContainer ${className ? className : ''}`,
			style: {
				...style,
				...frameHeight ? { maxHeight: frameHeight } : null,
				...frameWidth ? { maxWidth: frameWidth } : null
			},
			onScroll: this._scrolling
		}}>
			{
				mountRoot ? (
					<>
						{x ? <div {...{
								ref: ele => this._dom.ver = ele,
								className: 'frozen',
								style: {
									width: x,
									...yWidth ? { minWidth: yWidth } : null,
								}
							}}>{children}</div> : null}
						{y ? <div {...{
								ref: ele => this._dom.hor = ele,
								className: 'frozen',
								style: {
									height: y,
									...xWidth ? { minWidth: xWidth  } : null,
								}
							}}>{children}</div> : null}
						{
							x && y ? <div ref={ele => this._dom.cross = ele} className={'frozen cross'} style={{
								width: x,
								height: y,
							}}>{children}</div> : null
						}
						{children}
					</>
				) : null
			}

		</div>;
	}
}

/**
 * 替代 _ReactJ104Input 的進階版, 必須繼承使用!!
 */
class FormPureControl extends React.PureComponent {
	state = { enable: 1, editable: 1 };

	inputs = {};
	wVal = 0;
	wEvt = 0;
	wLock = {};
	/**
	 * 控制元件 readOnly 狀態, 上鎖期間 setValue 會於解鎖時才執行
	 * @param {string | number} index 元件鎖定原因索引, 全部索引解鎖才會真解鎖
	 * @param {boolean} locking 上鎖動作, falsy 值解鎖
	 */
	workLock(index, locking = 1) {
		if (locking) this.wLock[index] = 1;
		else delete this.wLock[index];

		if (Object.values(this.wLock).some(k => k)) {
			freeVal(this.inputs, false);
			this.setState({ editable: false, mixedBlood: true });
		} else {
			freeVal(this.inputs);
			this.setState({ editable: true, mixedBlood: true });
			if (this.wVal) {
				writeVal(this.inputs, this.wVal, this.wEvt);
				this.wVal = 0;
				this.wEvt = 0;
			}
		}

		return this;
	}

	setValue(v, fireEvent) {
		if (Object.values(this.wLock).some(k => k)) {
			this.wVal = { ...this.wVal, ...v };
			if (fireEvent) this.wEvt = fireEvent;
		} else writeVal(this.inputs, v, fireEvent);

		return this;
	}

	reset() {
		resetVal(this.inputs);

		const { initValue } = this.props;
		return initValue === undefined ? this : this.setValue(initValue);
	}

	validate() { return checkVal(this.inputs); }

	getValue() { return readVal(this.inputs); }

	constructor(props) {
		super(props);

		//可改變元件控制範圍
		if (props.inputs) this.inputs = props.inputs;
	}

	//==-- 直接繼承 _ReactJ104Input Start --==//
	isView() { return false; }

	isEnable() { return this.state.enable; }
	enable() {
		wakeVal(this.inputs);
		this.setState({ enable: true, mixedBlood: true });
		return this;
	}
	disable() {
		wakeVal(this.inputs, false);
		this.setState({ enable: false, mixedBlood: true });
		return this;
	}

	isEditable() { return this.state.editable; }
	editable(index = 0) { return this.workLock(index, 0); }
	readOnly(index = 0) { return this.workLock(index); }
	//==-- 直接繼承 _ReactJ104Input End --==//

	$ajaxs = [];

	/**
	 * Ajax 動作捷徑, 管理所有 ajax
	 * @param {*} opt Ajax 執行參數
	 * @param {string} idx 指定一個代號以重複使用連線
	 */
	jGet(opt, idx = 0) {
		const _ajax = new H2.Ajax(opt).send();
		if (idx) this.$ajaxs[idx] = _ajax;
		else this.$ajaxs.push(_ajax);

		return _ajax;
	}

	/**
	 * 檢查指定連線是否運行
	 * @param {string} idx 用 jGet 代號參數指定連線
	 */
	jCheck(idx) { return this.$ajaxs[idx] && this.$ajaxs[idx].isRunning(); }

	componentWillUnmount() { cancelAjax(this.$ajaxs); }

	pCache = {};
	/**
	 * 自訂 pureCache 的產出，預設用途有 ref 用的 refs 和 state 用的 stat
	 * @param {string} pattern 識別參數
	 */
	pFunc(pattern) {
		return {
			refs: ele => this.inputs[pattern] = ele,
			stat: v => this.setState({ [pattern]: v }),
		};
	}
	/**
	 * 為 PureComponent 打造的靜態屬性產生器, 可覆寫
	 * @param {string} usage 描述用途
	 * @param {string} pattern 識別參數
	 * @returns {*} 對應產生結果
	 */
	pureCache(usage, pattern) {
		if (!this.pCache[usage]) this.pCache[usage] = {};
		if (this.pCache[usage][pattern]) return this.pCache[usage][pattern];
		const item = this.pFunc(pattern)[usage];
		return item ? (this.pCache[usage][pattern] = item) : item;
	}

	/**
	 * 輔助 list 認識 numeric id
	 * @param {*} v 可能是字串的 id 值
	 * @returns {*} 數字轉數值, 否則保留原格式
	 */
	idxNum = v => isNaN(+v) ? v : +v;

	/**
	 * 提供元件同時接受 {id:name...} [{id,name}...] 的能力
	 * @param {*} v 輸入的屬性參數
	 * @returns {array} 一律產出陣列
	 */
	list = v => v
		? Array.isArray(v)
			? v.map(m => ({ ...m, id: this.idxNum(m.id) }))
			: Object.keys(v).map(id => ({ id: this.idxNum(id), name: v[id] }))
		: [];
}

/**
 * 偽裝 J104Radio 的進階版
 */
class ComplexRadio extends FormPureControl {
	static propTypes = {
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		onUpdate: PropTypes.func,
	};
	active = this.props.initValue;

	setValue(v, fireEvent) {
		const id = this.idxNum(v);
		if (this.active === id) return this;
		this.active = id;
		this.forceUpdate();
		if (fireEvent === false) return this;
		const { onUpdate } = this.props;
		if (onUpdate) onUpdate(id);
		return this;
	}

	validate() { return this.getValue() !== undefined; }

	getValue() { return (this.list(this.props.data).find(val => val.id == this.active) || 0).id; }

	render() {
		const { data, inline, style } = this.props;
		const { enable, editable } = this.state;
		const css = id => [
			'radioItem', id === this.active ? ' checked' : '', enable && editable ? '' : ' disable'
		];
		return <div className={`H2-Radio${inline === false ? ' block' : ''}`} style={style}>
			{this.list(data).map(({ id, name }) => (<div key={id} {...{
				className: css(id).join(''), style: inline === false ? {} : { display: 'inline-block' },
				onClick: () => enable && editable && this.setValue(id),
			}}><span className="radio"></span>{name}</div>))}
		</div>;
	}
}

/**
 * 單純的類別分頁框框
 */
class CateTabPanel extends React.PureComponent {
	static propTypes = {
		data: PropTypes.array.isRequired, //[{id,name}...]
		disp: PropTypes.func.isRequired, //產生分頁標題
		content: PropTypes.func.isRequired, //產生分頁內容
		on: PropTypes.string, //已選分頁呈現
		off: PropTypes.string, //一般分頁呈現
		style: PropTypes.object,
	};
	state = {};

	constructor(props) {
		super(props);
		const { data } = props;
		this.tabs = data.filter(o => !(o.active === 0));
		this.state.cTab = this.tabs[0].id;
	}

	render() {
		const { disp, content, off = 0, on = 'info', style } = this.props;
		const { cTab } = this.state;
		return (
			<>
				{this.tabs.map(t1 => (<Button.One key={t1.id} {...{
					type: t1.id === cTab ? on : off, style,
					onClick: () => t1.id === cTab || this.setState({ cTab: t1.id }),
				}}>{disp(t1)}</Button.One>))}
				{this.tabs.map(t2 => (
					<div key={t2.id} style={{ display: t2.id === cTab ? '' : 'none' }}>{content(t2)}</div>
				))}
			</>
		);
	}
}

/**
 * 類似 frameset 把頁面切割區塊，這是分割任意小區域的工具
 */
class VerticalColumnFrame extends React.PureComponent {
	static propTypes = {
		colClass: PropTypes.array,
		colStyle: PropTypes.array,
		colBody: PropTypes.array.isRequired,
	};

	/**
	 * 順序左、上、右、下，繼承者可以改預設值
	 */
	_options = {
		colClass: [],
		colStyle: [
			{ width: '20%', verticalAlign: 'top' },
			{ width: '78%', verticalAlign: 'top', marginLeft: 10 },
			{ display: 'none', verticalAlign: 'top' },
			{ display: 'none' }
		],
	};

	/**
	 * props 優先於 _options，若要改變此行為請繼承
	 */
	renderAdjust() {
		const { colClass, colBody } = this.props;
		const retOpts = { colClass: colClass || this._options.colClass, colStyle: [], colBody };
		const colStyle = this.props.colStyle || [];
		this._options.colStyle.forEach((cs, idx) => retOpts.colStyle[idx] = { ...cs, ...colStyle[idx] });
		return retOpts;
	}

	//元件核心不允許繼承
	render = () => {
		const {
			colClass: [cc1, cc2, cc3, cc4], colStyle: [cs1, cs2, cs3, cs4], colBody: [cb1, cb2, cb3, cb4],
		} = this.renderAdjust();
		return <>
			<div className={`inlineBlock ${cc1}`} style={cs1}>
				{typeof (cb1) === 'function' ? cb1() : cb1}
			</div>
			<div className={`inlineBlock ${cc2}`} style={cs2}>
				{typeof (cb2) === 'function' ? cb2() : cb2}
			</div>
			<div className={`inlineBlock ${cc3}`} style={cs3}>
				{typeof (cb3) === 'function' ? cb3() : cb3}
			</div>
			<div className={cc4} style={cs4}>
				{typeof (cb4) === 'function' ? cb4() : cb4}
			</div>
		</>;
	};
}

class WorkCalendar extends HAComponent {
	static propTypes = {
		date: PropTypes.oneOfType([
			PropTypes.instanceOf(window.Date), PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.array
		]),
		onDaySelect: PropTypes.func,
		onMonthSlide: PropTypes.func,
	};
	static MIN = moment('1900/1/1 00:00', 'YYYY/MM/DD HH:mm');
	static MAX = moment('2999/12/31 23:59', 'YYYY/MM/DD HH:mm');
	static DAYS = [
		['日', '一', '二', '三', '四', '五', '六'],
		['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		['日', '一', '二', '三', '四', '五', '六'],
	];
	state = {
		date: null,
		from: '',
		dataCache: {},
	};

	constructor(props) {
		super(props);
		const i18nIdx = LocaleUtils.i18nIdx();
		this._DAYS = WorkCalendar.DAYS[i18nIdx];
		this._min = WorkCalendar.MIN;
		this._max = WorkCalendar.MAX;

		const { date: propsDate } = this.props;
		if (propsDate) {
			const date = moment.isMoment(propsDate)
				? propsDate
				: _.isNumber(propsDate) || _.isDate(propsDate)
					? moment(propsDate)
					: _.isString(propsDate)
						? moment(propsDate, 'YYYY/MM/DD')
						: null;
			this.state.date = date && date.isBetween(this._min, this._max, 'date', '[]')
				? date
				: null;
		} else {
			this.state.date = moment().startOf('date');
		}
	}

	componentDidMount() {
		super.componentDidMount();
		this.fetchData();
	}

	fetchData() {
		const { empId } = this.props;
		const { date, dataCache } = this.state;
		if (!empId || !date) return;

		const year = date.get('year');
		const month = date.get('month');
		const cache = dataCache[`${year}_${month}`];
		if (cache) {
			this.setState(cache);
			return;
		}

		new H2.Ajax({
			url: '/api/m510010/calendarData',
			method: 'post',
			data: { empId, date },
			onRequest: () => this.setState({ loading: true }),
			onSuccess: (data, xhr) => {
				this.setState( {
					...data,
					dataCache: {
						...dataCache,
						[`${year}_${month}`]: data,
					}
				});

			},
			onComplete: xhr => this.setState({ loading: false }),
		}).send();
	}

	render(){
		const {_min, _max} = this;
		const { theme, onDaySelect, onMonthSlide, empId } = this.props;
		const { date, from, loading } = this.state;
		const day = date && date.get('date');
		const year = date.get('year');
		const month = date.get('month');
		const today = moment().startOf('date');

		const _prevBtn = isPrev => <span {... {
			className: `prev-btn btn ${loading ? 'disable' : ''}`,
			... !loading && isPrev ? {onClick: () => isPrev('Left')} : null
		}}><i {... {
			className: `fal fa-lg fa-angle-left${isPrev ? '' : ' na'}`,
		}} /></span>;

		const _nextBtn = isNext => <span {... {
			className: `next-btn btn ${loading ? 'disable' : ''}`,
			... !loading && isNext ? {onClick: () => isNext('Right')} : null
		}}><i {... {
			className: `fal fa-lg fa-angle-right${isNext ? '' : ' na'}`,
		}} /></span>;
		const _todayBtn = () => <div {...{
			className: 'today-btn',
			onClick: () => this.setState({
				date: today.clone(),
			}, () => {
				this.fetchData();
				_.isFunction(onDaySelect) ? onDaySelect(today.clone()) : null;
			})
		}}>
			<i className='fal fa-calendar-alt' style={{ marginRight: 4 }} />
			{OptionUtils.getLabel('components.utils', 'today')}
		</div>;
		const _renderCalendar = () => {
			const start = date.clone().startOf('month').startOf('date');
			const end = date.clone().endOf('month').startOf('date');
			const isPrev = end.clone().subtract(1, 'months').isAfter(_min)
				? from => {
					date.subtract(1, 'months');
					this.fetchData();
					this.state.from = from;
					this.forceUpdate(() => {
						if(_.isFunction(onMonthSlide)) onMonthSlide();
					});
				}
				: false;
			const isNext = start.clone().add(1, 'months').isBefore(_max)
				? from => {
					date.add(1, 'months');
					this.fetchData();
					this.state.from = from;
					this.forceUpdate(() => {
						if(_.isFunction(onMonthSlide)) onMonthSlide();
					});
				}
				: false;
			const _renderDefaultPrevCell = i => {
				const now = start.clone().subtract(start.day() - i, 'days');
				const available = now.isBetween(_min, _max, null, '[]');
				return <span {... {
					key: `pre_${i}`,
					className: `-cell day out${available ? '' : ' na'}`,
					... available
						? {
							onClick: () => this.setState({
								date: now.clone(),
								from: 'left',
							}, () => {
								this.fetchData();
								_.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null;
							})
						}
						: null,
				}}>{now.get('date')}</span>;
			};
			const _renderDefaultCell = i => {
				const day = i + 1;
				const now = moment(`${year}-${month + 1}-${day}`, 'YYYY-M-D');
				const available = now.isBetween(_min, _max, null, '[]');
				const selected = date && date.isSame(now, 'date');
				const today = moment().isSame(now, 'day');
				const { worktimeMap = {}, attendanceMap = {} } = this.state;
				const { calendarLeaveId: leaveId }  = worktimeMap[day] || {};
				const attendances = attendanceMap[day];
				const abnormal = attendances && attendances.filter(attendance => attendance.cardStatus === 2 || attendance.overStatus === 2).length > 0;
				return <span {... {
					key: `d_${i}`,
					className: `
						-cell day
						${selected ? ' selected' : ''}
						${today ? ' today ': ''}
						${available ? '' : ' na'}
						${empId && leaveId !== 1 ? 'not-work-day' : ''}
					`,
					... available ? {
						onClick: evt => {
							date.date(day);
							this.setState({date: date.clone()}, () => _.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null);
						}
					} : null,
				}}>
					{day}
					{abnormal ? <div className="red-dot"></div> : null}
				</span>;
			};
			const _renderDefaultNextCell = i => {
				const now = end.clone().add(i + 1, 'days');
				const available = now.isBetween(_min, _max, null, '[]');
				return <span {... {
					key: `next_${i}`,
					className: `-cell day out${available ? '' : ' na'}`,
					... available ? {
						onClick: evt => this.setState({
							date: now.clone(),
							from: 'right',
						}, () => {
							this.fetchData();
							_.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null;
						})
					} : null,
				}}>{now.get('date')}</span>;
			};
			return <>
				<div className={'-chead'}>{_prevBtn(isPrev)}<span className="year-month">{year}/{month < 9 ? '0' : ''}{month + 1}</span>{_nextBtn(isNext)} {_todayBtn()}</div>
				<div className={'-cbody'}>
					<div key={`m_${month}`} className={'-calendar'}>
						<div className={'-week'}>
							{_.times(7, i => <span key={`w_${i}`}>{this._DAYS[i]}</span>)}
						</div>
						{loading
							? <Loading size="lg"/>
							: <div className={`-days an-${from === 'upper' ? 'zoomInEnlarge' : `slideIn${from}-500`} an-250ms`}>
								{_.times(start.day(), i => _renderDefaultPrevCell(i))}
								{_.times(end.date(), i => _renderDefaultCell(i))}
								{_.times(6 - end.day(), i => _renderDefaultNextCell(i))}
							</div>
						}
					</div>
				</div>
			</>;
		};
		const _renderInfo = () => {
			const { worktimeMap = {}, attendanceMap = {}, shiftWorkTime = { stime: { 0: ''}, etime: { 0: '' } }, shiftWorkTimeRollback, loading, date } = this.state;
			const weekday = new Date(date).getDay();
			const [start, end] = (() => {
				const idx = weekday === 0 ? 6 : weekday - 1;
				const { stime, etime } = shiftWorkTimeRollback?.[date.format('YYYY-MM-DD')] || { stime: { 0: ''}, etime: { 0: '' } };
				if (stime[idx] === undefined) return [stime[0], etime[0]];
				return [stime[idx], etime[idx]];
			})();
			const { leaveName, calendarLeaveId: leaveId, holidayRule, shiftType }  = worktimeMap[day] || {};
			const attendances = attendanceMap[day];

			return <>{
				loading
					? <Loading size="lg"/>
					: <>
						<div id="info-block">
							<div className="title">
								{leaveId === 1 || leaveId === 2
									? <>
										<div>{date.format('YYYY/MM/DD')}&nbsp;{leaveName}</div>
										{leaveId === 1 &&
											<div>{`${start && end && shiftType === 1 ? `${getLabel('am.base.dayRange', start.substring(0, 10))} ${start.substring(11, 16)} ${OptionUtils.getLabel('components.utils', 'to')} ${end.substring(11, 16)}` : ''}`}</div>
										}
										{leaveId === 2 &&
											<div>{holidayRule}</div>
										}
									</>
									: leaveName
								}
							</div>
							<div className="work-table">
								{_.isArray(attendances) && attendances.length > 0
									? <table style={{ tableLayout: 'fixed' }}>
											<tbody>
											{attendances
												.map(attendance => (
													<tr key={attendance.id} className={attendance.cardStatus === 2 || attendance.overStatus === 2 ? 'color-red' : ''}>
														<td style={{width: '30%',whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{attendance.shiftName}</td>
														<td style={{width: '28%'}}>{attendance.label}</td>
														<td style={{width: '14%'}}>{attendance.time}</td>
														<td style={{width: '38%'}}>{attendance.statusName}</td>
													</tr>
												))
												.reduce((prev, curr, idx) => [prev, <tr key={`hr-${idx}`}><td><hr/></td><td><hr/></td><td><hr/></td><td><hr/></td></tr>, curr])
											}
											</tbody>
										</table>
									: <span>{OptionUtils.getLabel('components.utils', 'noInfo')}</span>
								}
							</div>
						</div>
						<div id="link">
							<Link to="/m410040" target="_blank" >{OptionUtils.getLabel('components.utils', 'seeMore')}<i className="fa fa-angle-right" style={{ margin: '0px 3px', fontSize: '1.1em' }} /></Link>
						</div>
					</>
			}</>;
		};
		return <div className={`H2-WorkCalendarPicker day ${theme ? theme : ''}`}>
			{_renderCalendar()}
			{_renderInfo()}
		</div>;
	}
}

const fontSizes = [
	'8px', '9px', '10px', '12px', '14px', '16px', '20px', '24px', '30px', '36px', '42px', '54px',
	'63px', '72px', '84px', '98px'
];
const _qInit = () => {
	const Size = Quill.import('attributors/style/size');
	Size.whitelist = fontSizes;
	Quill.register(Size, true);
};
/**
 * WYSIWYG 富文本編輯器，目前需配合 _qInit 才可以調字體大小
 * TODO: 換成 Lexical https://github.com/facebook/lexical
 */
class _RichText extends FormPureControl {
	constructor(props) {
		super(props);
		this._cont = props.content || '';
	}

	setValue(content, fireEvent) {
		if (content === this._cont) return;
		this._cont = content;
		if( _.isEqual('<p><br></p>', this._cont )) this._cont = '';
		this.forceUpdate(() => { if (this.props.onUpdate) this.props.onUpdate(this._cont); });
	}

	reset() {
		this._cont = '';
		this.forceUpdate(() => { if (this.props.onUpdate) this.props.onUpdate(this._cont); });
	}

	validate() {
		const { required, max = Number.MAX_SAFE_INTEGER } = this.props;
		return (!required || this._cont) && this.getValue().length <= max;
	}

	getValue() {
		const { text, lines = 9 } = this.props;
		if (text) {
			const ret = this._inst.getEditor().getText();
			return lines > 1 ? ret : ret.replace(/\n/g, '');
		} else {
			return this._cont.replace(/<p><br><\/p>/g, '<br>');
		}
	}

	insertTag(tag) {
		const editor = this._inst.getEditor();
		const range = editor.getSelection(true);
		if (!range) return;
		if (range.length) editor.deleteText(range.index, range.length);
		editor.insertText(range.index, tag);
	}

	render() {
		const { read, content: __html, onFocus, lines = 9, placeholder, className } = this.props;
		return read
			? <div {...{
				dangerouslySetInnerHTML: { __html },
				style: { maxHeight: 250, overflow: 'auto', ...this.props.style },
				className,
			}} />
			: <ReactQuill ref={ele => this._inst = ele} theme="snow" {...{
				value: this._cont, onChange: m => this.setValue(m), style: { height: lines > 1 ? 230 : 45 },
				onFocus, placeholder, modules: lines > 1
					? { toolbar: [{ size: fontSizes }, { color: [] }, 'clean'] }
					: {
						toolbar: 0, clipboard: { newLines: false, matchVisual: false },
						// keyboard: { bindings: { enter: { key: 13, handler: () => !1 } }, },
					},
			}} />;
	}
}

/**
 * @param {string | string[] | { [key: string]: boolean }} defaultClass
 * @param {{ [key: string]: boolean } | string[]} classObj
 * @returns {string | undefined}
 */
function classnames(defaultClass, classObj) {
	let className = '';
	let obj = Array.isArray(classObj) ? classObj.reduce((pre, cur) => ({ ...pre, [cur]: true }), {}) : classObj || {};
	if (Array.isArray(defaultClass)) {
		return defaultClass.join(' ');
	}
	if (typeof defaultClass === 'object') {
		obj = defaultClass;
	}
	for(const k in obj) {
		className += obj[k] ? ` ${k || ''}` : '';
	}
	const hasDefaultClass = typeof defaultClass === 'string' && defaultClass.trim() !== '';
	const returnClass = (hasDefaultClass ? defaultClass : '') + (hasDefaultClass && className.trim() ? ' ' : '') + className.trim();
	return returnClass ? returnClass : undefined;
}

const getViewWidth = () => {
	return document.documentElement.clientWidth;
};

const getOverWidth = (currentWidth) => {
	return currentWidth ? getViewWidth() < currentWidth : false;
};

const DragMultiWrapper = styled.div`
	padding-top: 4px;
	padding-left: 6px;
	.form-group {
		margin-bottom: 12px;
		.-idx {
			margin-top: 4px;
			width: 25px;
			height: 20px;
			border-radius: 10px;
			font-size: 12px;
			background-color: #f2f8ff;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.-tools {
			display: flex;
			font-size: 20px;
			align-items: center;
			padding-top: 4px;
			& > * {
				width: 20px;
				margin-right: 16px;
				cursor: pointer;
			}
		}
	}`;

function reorder(list, startIndex, endIndex) {
	const result = Array.from(list), [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
}

function DragBlock({
	provided, ids, setIds, InputItem, inputs, locales, required, moveBtns, droppableSnapshot, max,
	refData, fixMode, itemWidth, removing,
}) {
	return <div className="-block" ref={provided.innerRef} {...provided.droppableProps}>
		{ids.map((id, index) => {
			const reorderItem = destIndex => setIds(reorder(ids, index, destIndex));
			return <Draggable draggableId={id + ''} index={index} key={id}>
				{args => <div className="form-group" ref={args.innerRef} {...args.draggableProps}>
					<div className="col-xs-1" style={{
						marginTop: 5, visibility: ids.length > 1 ? '' : 'hidden'
					}}><DragBtn {...args.dragHandleProps} /></div>
					<div className="col-xs-1" style={{ padding: 0 }}>
						<div className="-idx">{index + 1}</div>
					</div>
					<div className={`col-xs-${itemWidth || 15}`}>
						<InputItem {...{ inputs, id, locales, required, refData }} />
					</div>
					<div className='-tools'>
						{ids.length > 1 && <>
							<RemoveBtn style={fixMode ? { visibility: 'hidden' } : {}} onClick={() => {
								if (ids.length < 2 || (removing && !removing(id, inputs))) return;
								delete inputs.current[id];
								setIds(ids.filter(_id => _id !== id));
							}} />
						</>}
						{moveBtns && <>
							{index > 0 && <RiseBtn onClick={() => reorderItem(index - 1)} />}
							{index + 1 < ids.length && <SinkBtn onClick={() => reorderItem(index + 1)} />}
							{index > 0 && <TopBtn onClick={() => reorderItem(0)} />}
							{index + 1 < ids.length && <BottomBtn onClick={() => reorderItem(ids.length - 1)} />}
						</>}
						{!fixMode && !droppableSnapshot.isUsingPlaceholder && index === ids.length - 1 &&
							ids.length < max ? <AddBtn onClick={() =>
								setIds([...ids, ids.reduce((prev, curr) => curr > prev ? curr : prev, 1) + 1])} />
							: <div style={{ width: 20 }}></div>}
					</div>
				</div>}
			</Draggable>;
		})}
		{provided.placeholder}
	</div>;
}

function useInputs(onUpdate, ref) {
	const [ids, setIds] = useState([1]);
	const inputs = useRef({ 1: {} });
	const [initValue, setInitValue] = useState([]);
	const [editable, setEditable] = useState(true);
	const isUpdate = useRef([1]);
	const isMount = useRef(false);
	const validate = useCallback(() => ids.every(id => Object.values(inputs.current[id] || 0)
		.every(val => val.validate())), [ids]);
	const getValue = useCallback(() => ids.map(id => {
		const input = inputs.current[id];
		return Object.keys(input || 0)
			.reduce((pre, key) => ({ ...pre, [key]: input[key].getValue() }), 0);
	}), [ids]);
	const setValue = useCallback(value => {
		if (!(value || []).length) return;
		isMount.current = false;
		setIds(value.map((_, index) => index + 1));
		setInitValue(value);
	}, []);
	useEffect(() => {
		if (!initValue.length || isMount.current) return;
		isMount.current = true;
		initValue.forEach((item, index) => {
			const input = inputs.current[ids[index]];
			Object.keys(input || 0).forEach(key => input[key].setValue(item[key]));
		});
	}, [initValue, ids]);
	useEffect(() => {
		if (isUpdate.current === ids) return;
		isUpdate.current = ids;
		onUpdate?.(getValue());
	}, [ids, onUpdate, getValue]);
	useImperativeHandle(ref, () => ({
		isEnable: () => true, validate, getValue, setValue, isEditable: () => editable,
		readOnly: () => setEditable(false), editable: () => setEditable(true),
	}), [validate, getValue, setValue, editable]);
	return { inputs, ids, setIds };
}

const DragMulti = forwardRef(({
	locales = ['zh_TW'], required, onUpdate, max = 30, multiPreset = false, InputItem, moveBtns,
	refData, fixMode, itemWidth, removing,
}, ref) => {
	const { inputs, ids, setIds } = useInputs(onUpdate, ref);
	return <DragMultiWrapper>
		<DragDropContext onDragEnd={result =>
			result.destination && setIds(reorder(ids, result.source.index, result.destination.index))}>
			<Droppable droppableId="list">
				{(provided, droppableSnapshot) => (
					<DragBlock setIds={_ids => setIds(_ids)}  {...{
						provided, droppableSnapshot, ids, locales, required, inputs, max, multiPreset, InputItem,
						moveBtns, refData, fixMode, itemWidth, removing,
					}} />
				)}
			</Droppable>
		</DragDropContext>
	</DragMultiWrapper>;
});
DragMulti.displayName = 'DragMulti';

/**
 * 偽裝 Checkbox 的輕量版
 */
class ComplexCheck extends FormPureControl {
	static propTypes = {
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		onUpdate: PropTypes.func,
		lock: PropTypes.oneOfType([PropTypes.function, PropTypes.boolean]),
	};

	_v2a = vs1 => (Array.isArray(vs1) ? vs1 : vs1 ? [vs1] : []).map(this.idxNum);

	actives = this._v2a(this.props.initValue || this.props.value);

	componentDidUpdate(...[prevProps]) {
		if (prevProps.value + '' == this.props.value + '') return;
		this.actives = this._v2a(this.props.value);
		this.forceUpdate();
	}

	setValue(vs2, fireEvent) {
		const vs3 = this._v2a(vs2);
		this.actives = vs3;
		this.forceUpdate(() => fireEvent !== false && this.props.onUpdate && this.props.onUpdate(vs3));
		return this;
	}

	getValue() {
		return this.list(this.props.data).reduce((acc, { id }) =>
			this.actives.includes(id) ? [...acc, id] : acc, []);
	}

	validate() {
		const error = this.props.validate?.required && !this.getValue().length && '必填';
		this.setState({ error });
		return !error;
	}

	render() {
		const { data, inline, lock, className, onUpdate } = this.props;
		const { enable, editable, error } = this.state;
		const able = item => enable && editable && !(typeof lock == 'function' ? lock(item) : lock);
		const css = item => [
			'checkboxItem', ...this.actives.includes(item.id) ? ['checked'] : [],
			...able(item) ? [] : ['disable'],
		].join(' ');
		const css2 = [
			'H2-Checkbox', ...error ? ['error'] : [], ...inline === false ? ['block'] : [],
			...className ? [className] : [],
		].join(' ');
		const _toggle = id => {
			this.actives.includes(id)
				? (this.actives = this.actives.filter(k => k != id))
				: this.actives.push(id);
			this.setState({ error: 0 }, () => onUpdate && onUpdate(this.actives));
		};
		return <div className={css2}>
			{this.list(data).map(item => <div key={item.id} className={css(item)}
				style={inline === false ? {} : { display: 'inline-block' }}
				onClick={() => able() && _toggle(item.id)}>
				<span className="checkbox"></span>{item.name}
			</div>)}
		</div>;
	}
}
/**
 * 檢查service.getConfigNavs中取得的特定funCode是否要呈現在前端畫面
 * @param {string} funCode 全大寫
 * @return {boolean}
 */
const checkConfigNav = (funCode) => {
	const { configNavigators } = H2;

	const c = funCode.toUpperCase().replace(/\//g, '');
	// 有設定為0就不顯示，其餘不論是設定為1或沒有此設定都先顯示
	if (configNavigators && configNavigators[c] === 0) {
		return false;
	} else {
		return true;
	}
};

const AuthModuleWrapper = ({ children }) => {
  const checkNode = (node) => {
    try {
      if (!node) return null;
      if (!_.isEmpty(node.props) && node.props.path) {
        // Routes上的path屬性直接拿來轉換成權限表的funCode格式
        return checkConfigNav(node.props.path) ? node : null;
      }

      // 如果傳進來的是Fragment
      if (typeof node.type === 'function') {
        const wrapElement = node.type(node.props);

        if (wrapElement.type === React.Fragment) {
          const wrappedChildren = React.Children.map(wrapElement.props.children, (child) => checkNode(child));
          return wrappedChildren;
        }
      } else if (typeof node.type === 'symbol' && Array.isArray(node.props.children)) {
        const arrayChildren = node.props.children.map((child) => checkNode(child));
        return arrayChildren;
      } else {
        return null;
      }
    } catch (error) {
      console.error('node error', error);
    }
  };

  // 複數個Routes傳進來時
  if (Array.isArray(children)) {
    return children.map((child) => checkNode(child));
  }

  // 單一個Routes傳進來時
  return checkNode(children);
};
/**
 * set hide:true to menu nodes includes in H2.configNavigators
 * @param {object} menu - MENU物件（源自menu.js or menu-portal.js 匯出的內容）
 * @param {object} configNavigators - 透過getConfigNavs取得寫在H2的參數
 * @returns {object} - 處理過的MENU物件
 */
const setMenuHide = (menu, configNavigators = null) => {
	const hideNodes = configNavigators || H2.configNavigators;

	if (!hideNodes) return menu;

	const processNode = (node, key) => {
		if (hideNodes[key] === 0) node.hide = true;
		if (node.children) {
			Object.keys(node.children).forEach((childKey) => {
				processNode(node.children[childKey], childKey);
			});
		}
	};

	Object.keys(menu).forEach((key) => {
		processNode(menu[key], key);
	});

	return menu;
};

export {
	ColGroup, _RichText, _qInit, DragMulti, ComplexCheck,
	TimeDisplayer, Freezing, FormPureControl, ComplexRadio, CateTabPanel, VerticalColumnFrame, WorkCalendar,
	classnames, getOverWidth, getViewWidth, checkConfigNav, AuthModuleWrapper, setMenuHide,
};
